<div
  class="select__view-value"
  #select
  (click)="open()"
  tabindex="0"
  [ngClass]="{ 'select--grey': theme === 'grey','select--resized-grey': theme === 'resized grey',
  'tasks--page': theme === 'tasks--page', disabled: disabled }"
>
  <div class="select__value" [ngClass]="{'resized': theme === 'resized grey'}">
    <p *ngIf="value" class="select__value-label">
      <i *ngIf="prefixIcon" class="material-icons">{{ prefixIcon }}</i>
      <span>{{ valueLabel }}</span>
    </p>
    <p *ngIf="!value" class="select__value-placeholder">
      <i *ngIf="prefixIcon" class="material-icons">{{ prefixIcon }}</i>
      <span>{{ placeholder }}</span>
    </p>
    <i class="material-icons select-icon"> keyboard_arrow_down </i>
  </div>
</div>

<ng-template #optionsContainer>
  <div
    class="select__options-container"
    [ngClass]="{ 'options--grey': theme === 'grey' || theme === 'resized grey' }"
    (click)="preventPropagation($event)"
    [ngStyle]="extraStyles"
  >
    <div class="select__options-label">
      <div class="select__value" [ngClass]="{'resized': theme === 'resized grey'}">
        <p *ngIf="value" class="select__value-label">
          <span>{{ valueLabel }}</span>
        </p>
        <p *ngIf="!value" class="select__value-placeholder">
          <span>{{ placeholder }}</span>
        </p>

        <input
          tabindex="-1"
          #suggestInput
          *ngIf="suggest"
          type="text"
          class="select__suggest-input"
          [(ngModel)]="searchString"
          placeholder="Search..."
        />
        <i class="material-icons select-icon"> keyboard_arrow_up </i>
      </div>
    </div>
    <ul class="select__options">
      <li
        (click)="selectEmptyOption(); preventPropagation($event)"
        class="select__option"
        *ngIf="empty && value"
      >
        {{ emptyLabel }}
      </li>
      <ng-container *ngIf="!optionGroups">
        <li
          *ngFor="
            let option of options | suggest: searchString:suggestSearchField
          "
          class="select__option"
          [ngClass]="{
            'option--selected': isOptionSelected(option),
            'option--capitalize': capitalize
          }"
          (click)="selectOption(option); preventPropagation($event)"
        >
          {{ getOptionLabel(option) }}
        </li>
      </ng-container>
      <ng-container *ngIf="optionGroups">
        <li
          *ngFor="let optionGroup of optionGroups"
          class="select__option select__option_group"
          [ngClass]="{
            select__option_collapsed: isOptionGroupCollapsed(optionGroup)
          }"
        >
          <div (click)="toggleOptionGroup(optionGroup)">
            {{ optionGroup[optionGroupLabel] }}
            <i class="material-icons select-icon"> keyboard_arrow_down </i>
          </div>
          <ul *ngIf="getGroupOptions(optionGroup).length">
            <li
              *ngFor="
                let option of getGroupOptions(optionGroup)
                  | suggest: searchString:suggestSearchField
              "
              class="select__option"
              [ngClass]="{
                'option--selected': isOptionSelected(option),
                'option--capitalize': capitalize
              }"
              (click)="selectOption(option); preventPropagation($event)"
            >
              {{ getOptionLabel(option) }}
            </li>
          </ul>
        </li>
      </ng-container>
      <li
        class="select__option select__option--null"
        *ngIf="
          !options ||
          (!(options | suggest: searchString:suggestSearchField).length &&
            suggest)
        "
      >
        No available options...
      </li>
    </ul>
  </div>
</ng-template>
